"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var format = _interopRequireWildcard(require("@/utils/format"));
var _configCommission = require("@/api/config-commission");
var _enum = require("@/utils/enum");
var _vuex = require("vuex");
var _lodash = require("lodash");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      configSystem: process.env.VUE_APP_CONFIG_SYSTEM,
      PARAMS: _enum.PARAMS,
      formData: {},
      listQuery: {},
      isLoading: false,
      loadingButton: false,
      tip: {},
      dialogStatus: "",
      dialogVisible: false,
      rules: {
        value: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập giá trị"
        }
      },
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  watch: {
    areas: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        if (newValue.length && !(0, _lodash.isEqual)(newValue, oldValue)) {
          this.$set(this.listQuery, "areaId", newValue[0].id);
          this.getData();
        }
      }
    }
  },
  created: function created() {
    this.$store.dispatch("area/fetchList");
  },
  methods: {
    formatVND: function formatVND(n) {
      return format.formatCurrency(n);
    },
    editData: function editData() {
      var _this = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.loadingButton = true;
          var data = {
            configCommission: _this.formData
          };
          _configCommission.configCommissionApi.update(_this.formData.id, data).then(function () {
            _this.$message({
              type: "success",
              message: "Cập nhật thành công"
            });
            _this.dialogVisible = false;
            _this.getData();
          }).finally(function () {
            _this.loadingButton = false;
          });
        }
      });
    },
    handleCreate: function handleCreate() {
      var _this2 = this;
      this.dialogStatus = "create";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs["form"].resetFields();
        _this2.formData = {};
      });
    },
    createData: function createData() {
      var _this3 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this3.loadingButton = true;
          var data = {
            encourage: _this3.formData
          };
          _configCommission.configCommissionApi.create(data).then(function () {
            _this3.$message({
              type: "success",
              message: "Tạo thành công"
            });
            _this3.dialogVisible = false;
            _this3.getData();
          }).finally(function () {
            _this3.loadingButton = false;
          });
        }
      });
    },
    handleEdit: function handleEdit(item) {
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.formData = (0, _objectSpread2.default)({}, item);
    },
    getData: function getData() {
      var _this4 = this;
      this.isLoading = true;
      _configCommission.configCommissionApi.findAll(this.listQuery).then(function (res) {
        if (res.data.length) {
          _this4.tableData = res.data;
        } else {
          _this4.initData();
        }
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _configCommission.configCommissionApi.init(this.listQuery);
            case 2:
              res = _context.sent;
              this.getData();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }()
  }
};